
// export const myGetter = ( input ) => {
//  return input
// }

export const inputsList = state => state.inputs
export const inputsSelectable = state => state.inputsSelectable
export const inputsPaginatedData = state => state.inputsPaginatedData
export const input = state => state.input
export const inputsCount = state => state.inputs.length
export const inputSelect = state => state.inputSelect
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData

export const cancelatedData = state => state.cancelatedData
export const isCancelating = state => state.isCancelating